import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom, selector, selectorFamily } from 'recoil';
import { DELIVERY_GEOFENCES_PAGE } from '../constants/app';
import { DeliveryFence, DeliveryFenceCore, DeliveryFenceRequest } from '../types/fence';
import { apiParamsState, pageState } from './app';

export const loadingDeliveryFencesState = atom({
  key: 'app.client.deliveryFences.loading',
  default: false,
});

export const deliveryFencesState = atom<PaginatedResponse<DeliveryFenceCore> | undefined>({
  key: 'app.client.deliveryFences',
  default: undefined,
});

export const deliveryFenceIdsState = selector<string[] | undefined>({
  key: 'app.client.deliveryFenceIds',
  get: ({ get }) => {
    const deliveryFences = get(deliveryFencesState);
    if (!deliveryFences) return;
    return deliveryFences.items.map((deliveryFence) => deliveryFence._id);
  },
});

export const deliveryFenceState = selectorFamily<DeliveryFenceCore | undefined, string>({
  key: 'app.client.deliveryFence',
  get:
    (id) =>
    ({ get }) => {
      const deliveryFences = get(deliveryFencesState);
      if (!deliveryFences?.items) return;
      return deliveryFences.items.find((deliveryFence) => deliveryFence._id === id);
    },
});

export const selectedDeliveryFenceIdState = atom<string | undefined>({
  key: 'app.client.deliveryFences.selectedId',
  default: undefined,
});

export const selectedDeliveryFenceState = atom<DeliveryFence | undefined>({
  key: 'app.client.deliveryFence.selected',
  default: undefined,
});

export const editSelectedDeliveryFenceState = atom({
  key: 'app.client.deliveryFences.selected.edit',
  default: false,
});

export const searchDeliveryFenceState = atom<string | undefined>({
  key: 'app.client.deliveryFences.search',
  default: undefined,
});

export const deliveryFencesPageState = atom({
  key: 'app.client.deliveryFences.page',
  default: 1,
});

export const editingDeliveryFenceState = atom<DeliveryFenceRequest | undefined>({
  key: 'app.client.deliveryFences.editing',
  default: selector({
    key: 'app.client.deliveryFences.editing.initializer',
    get: ({ get }) => {
      const selectedDeliveryFence = get(selectedDeliveryFenceState);
      if (!selectedDeliveryFence) {
        const apiParams = get(apiParamsState);
        if (!apiParams) return;
        return {
          _id: '',
          clientId: apiParams.clientId,
          subClientId: apiParams.subClientId,
          name: '',
          active: true,
          geoReference: '',
          polygon: undefined,
        } as DeliveryFenceRequest;
      }
      return {
        ...selectedDeliveryFence,
        clientId: selectedDeliveryFence.client,
        subClientId: selectedDeliveryFence.subClient,
      };
    },
  }),
});

export const updateDeliveryFencesState = atom<string | undefined>({
  key: 'app.client.deliveryFences.update',
  default: undefined,
});

export const showDeliveryFenceControlsState = selector({
  key: 'app.client.deliveryFences.map.controls',
  get: ({ get }) => {
    const page = get(pageState);
    if (page !== DELIVERY_GEOFENCES_PAGE.id) return false;
    const selectedDeliveryFenceId = get(selectedDeliveryFenceIdState);
    if (selectedDeliveryFenceId === undefined) return false;
    const isEditing = get(editSelectedDeliveryFenceState);
    return isEditing;
  },
});
